var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container flex",staticStyle:{"margin-bottom":"20px","margin-top":"15px"}},[_c('div',[_c('left')],1),_vm._v(" "),_c('div',{staticClass:"flex1",staticStyle:{"margin-left":"20px"}},[_c('right',{attrs:{"title":_vm.title,"list":_vm.list,"questionsStatus":_vm.questionsStatus}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42c139c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/highfrequency.vue
// module id = null
// module chunks = 